<template>
  <v-app :class="[template.app_class, $route.name]" v-resize="onResize" :id="supplier_slug">
    <layout-header-nav-bar v-if="template.header_display 
                                && instance.id !== undefined 
                                && instance.status !== 'locked'
                                && !instance.cluvi_add_ons.includes('newhome')
                                " />
    <new-home-Header-Nav-Bar v-if="template.header_display 
                                && instance.id !== undefined 
                                && instance.status !== 'locked'
                                && instance.cluvi_add_ons.includes('newhome')
                                " />
    <panel-left v-if="template.panel_left && instance.id !== undefined" />
    <v-main v-if="reloadIndexedDB && instance.id !== undefined">
      <call-waiter
        v-if="((is_ontable_checkout || is_ontable_noincremental) && tableId !=='' && !is_room_service) && !template.loading && instance.slug !== ('rayados' || 'rayados-mty')"
        :tableId="tableId"
        ref="callWaiterComponent"
      />
      <router-view @callWaiter="$refs.callWaiterComponent.callTheWaiter()" />
    </v-main>
    <service-cookies v-if="!legal.check_cookies && instance.id !== undefined && instance.id !== null && instance.id.toString().length > 0 && !this.instance.cluvi_add_ons.includes('newhome')" />
    <loader-splash v-if="template.loading || !reloadIndexedDB" />
    <pop-ups v-if="validatePopupModule && supplier.id > 0 && service" :see-product="seeProduct" />
    <modal-product v-if="seeProduct" @closeProduct="closeProduct" />
    <error-dialog v-if="error.show" :data="error" @DismissErrorDialog="dismissErrorDialog" />
  </v-app>
</template>

<script>
import * as Sentry from "@sentry/vue";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { vuetifyCustom } from "./services/vuetify-custom";
import { track } from "./services/track-custom";
import { dbFunctions } from "@/services/indexedDB";
import { featureFlag } from "./services/featureFlag";

export default {
  name: "App",
  data: () => ({
    params: {},
    seeProduct: false,
    supplier_slug: "",
    menuDigitalView: false,
    dogImage: null,
    counter: 0,
    IndexDbLoadedFirtsTime: false,
    reloadNewIndexDb: false,
    version: process.env.VUE_APP_VERSION
  }),
  components: {
    PopUps: () => import(/* webpackChunkName: "popUps" */  "@/components/publicidad/PopUps"),
    LayoutHeaderNavBar: () => import(/* webpackChunkName: "LayoutHeaderNavBar" */  "./components/layout/HeaderNavBar"),
    NewHomeHeaderNavBar: () => import(/* webpackChunkName: "NewHomeHeaderNavBar" */  "./components/layout/NewHomeHeaderNavBar"),
    LoaderSplash: () => import(/* webpackChunkName: "LoaderSplash" */  "./components/layout/LoaderSplash"),
    PanelLeft: () => import(/* webpackChunkName: "PanelLeft" */  "./components/layout/PanelLeft"),
    ServiceCookies: () => import(/* webpackChunkName: "serviceCookies" */  "@/components/legal/ServiceCookies"),
    ModalProduct: () => import(/* webpackChunkName: "modalProduct" */  "@/views/product/ModalProduct"),
    CallWaiter: () => import(/* webpackChunkName: "callWaiter" */  "@/components/on_table/CallWaiter"),
    ErrorDialog: () => import(/* webpackChunkName: "ErrorDialog" */ "@/components/cluvi-pay/ErrorDialog.vue")
  },
  computed: {
    ...mapState("shared", ["legal", "product_id", "windowSize", "lang", "error"]),
    ...mapState("template", ["template", "loading", "isFirefox", "reloadIndexedDB"]),
    ...mapState("ontable", ["tableId", "flatSavedDataIndexedDb"]),
    ...mapState("order", ["countProductsList", "purchaseId", "service"]),
    ...mapState("profile", ["session", "profile"]),
    ...mapState("customer", ["supplier", "instance", "isCinemark"]),
    ...mapGetters("order", ["is_room_service", "is_ontable_service"]),
    ...mapGetters("customer", ["is_ontable_checkout", "is_ontable_noincremental", "is_ontable_basic"]),
    validatePopupModule() {
      return !(this.$route.name === "Main" ||
        this.$route.name === "Location" ||
        this.$route.name === "BranchOnTable" ||
        this.$route.name === "BranchToTakeAway" ||
        this.$route.name === "BranchWithOutService" ||
        this.$route.name === "BranchToBook");
    }
  },
  watch: {
    supplier(newVal, oldVal) {
      if (newVal.id !== oldVal.id && newVal.id > 0) this.updateIndexedb();
      if (this.is_ontable_service) this.changeSupplierForUrl(newVal, oldVal);
      if (newVal.slug) this.supplier_slug = newVal.slug;
      if (!newVal.locale || newVal.locale?.length || newVal.locale === this.$i18nlocale) return;
      this.setI18nFileByLang(this.instance.langs.length ? this.lang : newVal.locale);
    },
    product_id (val) {
      if (val === null || val === undefined || val.toString().length <= 1) {
        this.seeProduct = false;
        this.params = {};
      } else {
        this.params = {
          supplier_id: this.supplier.slug,
          product_id: this.product_id
        };
        this.seeProduct = true;
      };
    },
    $route() {
      if (this.$route.name === "OnTableMenuDigital") this.menuDigitalView = true;
      else this.menuDigitalView = false;
      if (this.$route.name === "MyOrder") this.$vuetify.theme.dark = false;
      else this.$vuetify.theme.dark = this.instance.theme.dark;
    },
    lang() {
      if (this.service === "on_table" && !this.isFirefox) {
        this.updateIndexedb();
      }
    },
    service (newVal) {
      if (newVal === 'on_table') {
        this.updateIndexedb();
      }
    }
  },
  created() {
    //Temporal se debe ajustar cuando este pulido indexdb
    this.setisFirefox(true);
    /*
    if (!this.reloadIndexedDB) {
      this.setisFirefox(true);
      this.SetReload(true);
      track.trackEventCluvi({}, "IndexDB set ModeApi");
    }
    */
    try {
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get("session_id") !== undefined && urlParams.get("session_id") !== null && urlParams.get("session_id").length > 5){
        const dataSession = {"id":urlParams.get("session_id")}
        this.setSession(dataSession);
      }
    } catch (error) {
      console.log(error)
    }
    this.initCluvi();
  },
  methods: {
    ...mapMutations("template", ["CloseLeftPanel", "SetLoading", "SetInitToMenu", "SetReload", "setisFirefox"]),
    ...mapMutations("order", ["setService", "SetCountProductsList"]),
    ...mapMutations("customer", ["SetSupplier","SetDisableTip", "SetValueOrderMin","SetIsCinema"]),
    ...mapMutations("shared", ["setWindowSize", "SetProductId", "setLanguage", "setError"]),
    ...mapMutations("ontable", ["setFlatSavedDataIndexedDb"]),
    ...mapMutations("profile", ["setSession"]),
    ...mapActions("customer", ["InitInstance", "GetSupplier"]),
    async initCluvi() {
      try {
        this.SetReload(false);
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get("service") !== undefined && urlParams.get("service") !== null) this.setService(urlParams.get("service"));
        this.SetProductId(null);
        this.SetLoading(true);
        await this.InitInstance();
        vuetifyCustom.init(this, this.instance);
        track.load();
        this.CloseLeftPanel();
        this.onResize();
        this.setLang();
        this.SetInitToMenu(false);
        this.createAcquisition();
        this.validateNeedSupplier();
        if (this.instance.status === "locked") this.$router.push({ name: "InactiveInstance" });
      } catch (error) {
        this.SetReload(true);
        Sentry.captureException(error);
      }

    },
    onResize() {
      this.setWindowSize({
        x: window.innerWidth,
        y: window.innerHeight,
        is_movile: null
      });
    },
    setLang() {
      const langInstance = this.instance.language.toLowerCase();
      if (this.lang !== "") {
        this.setI18nFileByLang(this.lang);
      } else if (["es", "en", "pt"].includes(langInstance)) {
        this.setLanguage(langInstance);
        this.setI18nFileByLang(langInstance);
      } else {
        this.setLanguage("es");
        this.setI18nFileByLang("es");
      }
    },
    closeProduct() {
      this.SetProductId(null);
      this.seeProduct = false;
    },
    createAcquisition() {
      if (this.instance.id !== null && this.instance.id !== undefined && this.session.id !== null && this.session.id !== undefined && this.session.id.length > 0) {
        track.storeAcquisitionData(window.location.search, this.session.id, this.instance.id);
      } else {
        setTimeout(() => this.createAcquisition(), 1500);
      }

    },
    setI18nFileByLocale(locale) {
      switch (locale) {
        case "pt-BR":
          this.$i18n.locale = "pt";
          break;
        case "en-US":
          this.$i18n.locale = "en";
          break;
        default:
          this.$i18n.locale = "es";
      }
    },
    setI18nFileByLang(lang) {
      this.$i18n.locale = lang;
    },
    dismissErrorDialog() {
      this.error.show = false;
    },
    changeSupplierForUrl(newVal, oldVal) {
      if (this.flatSavedDataIndexedDb && newVal.id !== 0) this.setFlatSavedDataIndexedDb(false);
      if (newVal.id > 0 && oldVal.slug && (newVal.slug !== oldVal.slug)) {
        if (this.$route.name === "SubCategories") {
          this.$router.push({
            name: "Home",
            params: { supplier_id: newVal.slug }
          });
        }

      }
    },
    updateIndexedb() {
      const data = 0;
      (data)
      /*
      if(!this.reloadIndexedDB){
        this.reloadNewIndexDb = true;
      }
      if (this.reloadIndexedDB && this.is_ontable_service && this.supplier.id && this.supplier.id > 0) {
        this.SetReload(false);
        dbFunctions.menuCache().then((value) => {
          this.SetReload(true);
          if(this.reloadNewIndexDb){
            this.reloadNewIndexDb = false;
            this.updateIndexedb();
          }
          (value)
        })
          .catch((err) => {
            this.setisFirefox(true);
            this.SetReload(true);
            track.trackEventCluvi({}, "IndexDB set ModeApi by updateIndexedb ");
            Sentry.captureException(err);
          });
        this.startTimer();
      }
      */

    },
    startTimer() {
      this.timer = setInterval(() => dbFunctions.getReloadMenuCache(), 60000);
    },
    async validateNeedSupplier() {
      const slug = this.$route.params.supplier_id;
      if( !(this.$route.name === 'MainCategories' 
          || this.$route.name === 'SubCategories'
          || this.$route.name === 'Home'
          || this.$route.name === 'OnTableHome'
          || this.$route.name === 'MyOrder'
          ) 
      )
      {
        this.SetReload(true);
        return;
      }
      if(this.supplier.slug && this.supplier.slug === slug){
        this.SetReload(true);
        return;
      }
      try {
        await this.GetSupplier(this.$route.params.supplier_id);
      } catch (error) {
        (error)
      } finally {
        this.SetReload(true);
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  mounted() {
    this.updateIndexedb();
    setTimeout(() => {
      featureFlag.connetGrowthBook();
      featureFlag.valueFeature("disable-tip").then(value => {
        this.SetDisableTip(value);
      }).catch(() => {
        this.SetDisableTip(false);
      });
      featureFlag.valueFeature("enable-minimum-order-value").then(value => {
        this.SetValueOrderMin(value);
      }).catch(() => {
        this.SetValueOrderMin(false);
      });
      featureFlag.valueFeature("enable-plano-zona").then(value => {
        this.SetIsCinema(value);
      }).catch(() => {
        this.SetIsCinema(false);
      });
    }, process.env.VUE_APP_DELAY);

    /*
    if (this.isFirefox) {
      track.trackEventCluvi({}, "IndexDB User With ModeApi");
    }
    */
  },
  metaInfo: {
    meta: [
      { vmid: "description", name: "description", content: `timestamp: ${process.env.VUE_APP_TIMESTAMP}` },
      { property: "og:timestampbuild", content: process.env.VUE_APP_TIMESTAMP }
    ]
  }
};
</script>

<style lang="scss">
@import "styles/custom.scss";

$fa-font-path: "styles/fontawesome/webfonts";
@import "styles/fontawesome/css/all.min.css";
@import "styles/fontawesome/css/sharp-light.min.css";
@import "styles/fontawesome/css/sharp-regular.min.css";
@import "styles/fontawesome/css/sharp-solid.min.css";
footer {
  background-color: transparent !important;
}
</style>
